<div class="col-md-12">
    <mat-dialog-content class="access-requests-container">
        <div class="dialog-info">
            <label class="dialogTitle">{{ 'EDITOR_ACCESS_REQUESTS' | translate }}</label>
            <div class="crossButtonPosition">
                <button type="button" class="close-icon btn-close btn-close-white shadow-none" (click)="closeElement()"></button>
            </div>
        </div>
        <div class="table-responsive">
            <section class="small-table">
                <table mat-table [dataSource]="dataSource" class="compact-table access-requests-table">

                    <ng-container matColumnDef="requestorName">
                        <td mat-cell *matCellDef="let element"> {{ element.requestorName }} </td>
                    </ng-container>

                    <ng-container matColumnDef="requestMessage">
                        <td mat-cell *matCellDef="let element"> {{ element.requestMessage }} </td>
                    </ng-container>

                    <!-- No header row — rows only -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </section>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-footer">
        <button mat-raised-button color="primary" (click)="onAcceptDiscard()">
            {{ 'ACCEPT_DISCARD_CHANGES' | translate }}
        </button>
        <button mat-raised-button color="primary" (click)="onAcceptPublish()">
            {{ 'ACCEPT_PUBLISH' | translate }}
        </button>
        <button mat-raised-button color="warn" (click)="onDecline()">
            {{ 'DECLINE' | translate }}
        </button>
    </mat-dialog-actions>
</div>